import * as React from 'react'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import formAccessGroupMemberships from 'modules/surveys/store/collections/formAccessGroupMemberships'
import type Form from 'modules/surveys/store/models/Form'

export function useFormAccessGroup(form: Form) {
  const [accessGroup, setAccessGroup] = React.useState()

  const { loading } = useUnsafeAsyncData(async () => {
    const access_group = await formAccessGroupMemberships.fetch({
      data: {
        form_id: form.attributes.id,
        access_group_id: form.attributes.access_group_id,
      },
    })
    setAccessGroup(access_group)
  }, [form])

  return {
    accessGroup,
    loading,
  }
}
